import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV = [
  { label: "The reality", href: "/#reality" },
  { label: "How it works", href: "/#how" },
  { label: "Marketplace", href: "/marketplace" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Avni", href: "/#avni" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathname, hash]);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 transition-all ${
        scrolled
          ? "backdrop-blur-xl bg-white/75 border-b border-slate-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center group">
          <img
            src="/logo.png"
            alt="Freelancity — Resume to AI Freelancer"
            className="h-9 md:h-10 w-auto transition-transform group-hover:scale-[1.02]"
            width="240"
            height="40"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <Link
              key={n.label}
              to={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="px-3 py-2 text-sm text-slate-600 hover:text-slate-900 rounded-md hover:bg-slate-100 transition whitespace-nowrap"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        {/* Desktop right cluster: scales with screen size — compact on md laptops, normal on lg+ */}
        <div className="hidden md:flex items-center gap-1.5 lg:gap-2">
          <Link
            to="/build"
            data-testid="nav-build-agent"
            className="inline-flex items-center gap-1.5 lg:gap-2 rounded-md border border-slate-300 bg-white text-slate-800 px-3 py-1.5 text-xs lg:px-3.5 lg:py-2 lg:text-sm font-medium hover:border-blue-400 hover:text-blue-700 whitespace-nowrap transition"
          >
            <span className="relative inline-flex w-1.5 h-1.5">
              <span className="absolute inset-0 rounded-full bg-emerald-500/60 animate-ping" />
              <span className="relative inline-block w-1.5 h-1.5 rounded-full bg-emerald-500" />
            </span>
            Live Demo
          </Link>
          <a
            href="/#waitlist"
            data-testid="nav-cta-build"
            className="inline-flex items-center gap-1 lg:gap-2 rounded-md bg-blue-600 text-white px-3 py-1.5 text-xs lg:px-4 lg:py-2 lg:text-sm font-medium hover:bg-blue-700 hover:-translate-y-0.5 transition whitespace-nowrap shadow-[0_8px_24px_-12px_rgba(37,99,235,0.7)]"
          >
            Join waitlist
          </a>
        </div>

        {/* Mobile/tablet right cluster: tiny on small phones, slightly larger on sm */}
        <div className="md:hidden flex items-center gap-1 sm:gap-1.5">
          <Link
            to="/build"
            data-testid="mobile-nav-build-agent"
            className="inline-flex items-center gap-1 sm:gap-1.5 rounded-md border border-slate-300 bg-white text-slate-800 px-2 py-1 text-[10px] sm:px-2.5 sm:py-1.5 sm:text-[11px] font-medium hover:border-blue-400 hover:text-blue-700 whitespace-nowrap transition"
          >
            <span className="relative inline-flex w-1.5 h-1.5">
              <span className="absolute inset-0 rounded-full bg-emerald-500/60 animate-ping" />
              <span className="relative inline-block w-1.5 h-1.5 rounded-full bg-emerald-500" />
            </span>
            Live Demo
          </Link>
          <a
            href="/#waitlist"
            data-testid="mobile-nav-cta"
            className="inline-flex items-center rounded-md bg-blue-600 text-white px-2 py-1 text-[10px] sm:px-2.5 sm:py-1.5 sm:text-[11px] font-medium hover:bg-blue-700 whitespace-nowrap transition shadow-[0_4px_14px_-8px_rgba(37,99,235,0.7)]"
          >
            Join waitlist
          </a>
        </div>
      </div>
    </header>
  );
}
